import $ from "jquery";
window.$ = window.jQuery = $;
import Inputmask from "inputmask";
import 'jquery-validation';
require('./swiper');
require('./form');
require('./gtm_events');
require('./modal');
import lightGallery from 'lightgallery';


$(document).ready(function () {

    lightGallery(document.getElementById('lightgallery'), {
        speed: 500
    });

    lightGallery(document.getElementById('lightgalleryReviews'), {
        selector: '.reviews__item-footer-image', // все ссылки внутри
    });

    document.querySelectorAll('.lightgalleryGalleries').forEach(function (el) {
        lightGallery(el, {
            selector: '.services-galleries__item'
        });
    });

    document.querySelectorAll('.lightgalleryList').forEach(function (el) {
        lightGallery(el, {
            selector: '.reviews-page__image-item'
        });
    });

    function initPhoneMask() {
        const im = new Inputmask("+\\(380\\) 99-999-99-99", {
            clearIncomplete: true,
            showMaskOnHover: false,
        });

        im.mask($('input[name="user_phone"]'));
    }
    window.initPhoneMask = initPhoneMask;
    initPhoneMask()

    function toggleTabs(tabsBtn, tabsItem, contentItem) {
        tabsBtn.on('click', function () {
            tabsBtn.removeClass('active');
            $(this).addClass('active');

            let index = $(this).closest(tabsItem).data('tabs');

            contentItem.removeClass('active');

            contentItem.filter(`[data-content="${index}"]`).addClass('active');
        });
    }

    toggleTabs($('.services-info__tabs-btn'), $('.services-info__tabs-item'), $('.services-info__content-item'))
    toggleTabs($('.video__tabs-btn'), $('.video__tabs-item'), $('.video__content-item'))

    toggleTabs($('.search-page__tabs-btn'), $('.search-page__tabs-item'), $('.search-page__content-item'))

    $('.js-cities-chose').click(function () {
        $('.js-cities-list').slideToggle();
    })

    $(window).scroll(function () {
        if ($(this).scrollTop() > 300)
            $('.js-up-btn').fadeIn();
        else
            $('.js-up-btn').fadeOut();
    });
    $('.js-up-btn').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
    });

    function updateMainPadding() {
        let heighHeader = $('.header').outerHeight();
        $('.main').css('padding-top', heighHeader + 'px');
    }

    $(window).on('load resize', function () {
        updateMainPadding();
    });

    $(window).on('scroll', function () {
        const scrolled = $(this).scrollTop();
        $('.picture--parallax_60 .picture__img').css(
            'transform',
            'translate3d(0, ' + (scrolled * 0.6) + 'px, 0)'
        );
    });

    $('.js-more-about').on('click', function () {
        $('.about-center__info p').show();
        $(this).hide();
        $('.js-hide-about').show();
    });

    $('.js-hide-about').on('click', function () {
        $('.about-center__info p:not(:nth-child(2))').hide();
        $(this).hide();
        $('.js-more-about').show();
    });


    let itemsToShow = 4;
    let itemsTotal = $('.js-articles__item').length;
    let currentlyShown = itemsToShow;

    $('.js-articles__item').hide().slice(0, itemsToShow).show();

    $('.js-btn-more-articles').on('click', function () {
        $('.js-btn-hide-articles').show();
        currentlyShown += itemsToShow;

        $('.js-articles__item').slice(0, currentlyShown).fadeIn();

        if (currentlyShown >= itemsTotal) {
            $(this).hide();
        }
    });

    $('.js-btn-hide-articles').on('click', function () {
        $(this).hide();
        $('.js-btn-more-articles').show();
        $('.js-articles__item').hide().slice(0, itemsToShow).show();
    });


    $(document).on('click', '.js-open-form-item', function () {
        $(this).hide();
        $('.reviews-page__form-item').show();
    });

    $(document).on('click', '.js-hide-form-item', function () {
        $('.reviews-page__form-item').hide();
        $('.js-open-form-item').show();
    });


    $('.js-open-spoiler').on('click', function () {
        $(this).closest('.main-spoiler__wrap').find('.main-spoiler__item-content').slideToggle();
        $(this).find('.main-spoiler__icon-plus').toggle();
        $(this).find('.main-spoiler__icon-minus').toggle();
    });

    $('.js-open-video').on('click', function () {
        let videoId = $(this).data('src');
        let videoUrl = `https://www.youtube.com/embed/${videoId}`
        $('.video__modal iframe').attr('src', videoUrl);

        $('.video__modal-wrap').addClass('active');
        $('body').addClass('hidden');
    });

    $('.video__modal-overlay').on('click', function () {
        $('.video__modal-wrap').removeClass('active');
        $('body').removeClass('hidden');
        $('.video__modal iframe').attr('src', 'https://www.youtube.com/embed/');
    });

    const $win = $(window);

    $win.on('scroll', function () {
        const scrolled = $win.scrollTop();
        const windowHeight = $win.height();
        const screenWidth = $win.width();

        $('[data-parallax]').each(function () {
            const $el = $(this);
            const offset = $el.offset().top;
            const height = $el.outerHeight();

            if (scrolled + windowHeight > offset && scrolled < offset + height) {
                let speed = $el.data('parallax');

                // адаптив под мобилки
                if (screenWidth < 1024) {
                    speed = speed * 0.3; // уменьшаем силу эффекта
                }

                const yPos = (scrolled - offset) * speed;
                $el.find('img').css('transform', `translate3d(0, ${yPos}px, 0)`);
            }
        });
    });

    $('.main-spoiler').each(function () {
        let spoilerCount = $(this).find('.main-spoiler__wrap').length;

        if (spoilerCount <= 5) {
            $(this).find('.js-spoiler-show').hide();
        }
    });


    $('.js-spoiler-show').on('click', function () {
        $(this).hide();
        $('.js-spoiler-hide').show();
        $('.main-spoiler__wrap').addClass('active');
    });

    $('.js-spoiler-hide').on('click', function () {
        $(this).hide();
        $('.js-spoiler-show').show();
        $('.main-spoiler__wrap').removeClass('active');
    });


    $(document).on('click', '.services-search__letters-item button', function () {
        const litter = $(this).text().trim().toUpperCase();

        $('.services-search__alphabet').each(function () {
            if ($(this).text().trim().toUpperCase() == litter) {
                $(this).closest('.services-search__item').show();
            } else {
                $(this).closest('.services-search__item').hide();
            }
        });
    });

    $(document).on('input', '.js__search', function () {
        const query = $(this).val().toLowerCase().trim();

        $('.services-search__item').each(function () {
            let hasMatch = false;

            $(this).find('.services-search__unit').each(function () {
                const serviceName = $(this).find('.services-search__link').text().toLowerCase();

                if (query === '' || serviceName.includes(query)) {
                    $(this).show();
                    hasMatch = true;
                } else {
                    $(this).hide();
                }
            });

            if (hasMatch) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });

    $(document).on('click', '.js-reset-services-list', function () {
        $('.js__search').val('');
        $('.services-search__item').show();
        $('.services-search__unit').show();
    });

    $('.js_show-all-price').on('click', function () {
        $(this).hide();
        $(this).closest('.page-link-btn__wrap').find('.js_hide-all-price').show();
        $(this).closest('.services-price__item').find('.services-price__tbody-tr').addClass('active');
    });

    $('.js_hide-all-price').on('click', function () {
        $(this).hide();
        $(this).closest('.page-link-btn__wrap').find('.js_show-all-price').show();
        $(this).closest('.services-price__item').find('.services-price__tbody-tr').removeClass('active');
    });

    $(document).on('click', '.js-anchor-scroll', function () {
        const targetId = $(this).data('anchor');
        const targetElement = $('#' + targetId);

        if (targetElement.length) {
            const headerHeight = $('.header').outerHeight() || 0;

            $('html, body').animate({
                scrollTop: targetElement.offset().top - headerHeight - 40
            }, 600, function () {
                // получаем текущий URL без хеша
                const currentUrl = window.location.href.split('#')[0];
                // добавляем хеш в конец
                window.history.pushState(null, null, currentUrl + '#' + targetId);
            });
        }
    });

    let anchor = $('.js-anchor-item');
    let header = $('.header');

    if (anchor.length) {
        let offsetTop = anchor.offset().top;
        let $nextBlock = anchor.next();
        let originalPaddingTop = parseInt($nextBlock.css('padding-top')) || 0;

        $(window).on('scroll resize', function () {
            let scrollTop = $(window).scrollTop();
            let headerHeight = header.outerHeight();
            let anchorHeight = anchor.outerHeight();

            if (scrollTop >= offsetTop) {
                anchor.addClass('fixed').css('top', headerHeight + 'px');

                // проверяем ширину экрана
                if ($(window).width() <= 567) {
                    $nextBlock.css('padding-top', originalPaddingTop + anchorHeight + 70);
                } else {
                    $nextBlock.css('padding-top', originalPaddingTop + anchorHeight);
                }
            } else {
                anchor.removeClass('fixed').css('top', '0');

                // возвращаем исходный отступ
                $nextBlock.css('padding-top', originalPaddingTop);
            }

            $('.js-anchor-scroll').each(function () {
                let targetId = $(this).data('anchor');
                let targetElement = $('#' + targetId);

                if (targetElement.length) {
                    let elementTop = targetElement.offset().top - headerHeight - 80;
                    let elementBottom = elementTop + targetElement.outerHeight();

                    if (scrollTop >= elementTop && scrollTop < elementBottom) {
                        $('.js-anchor-scroll').removeClass('active');
                        $(this).addClass('active');
                        return false;
                    }
                }
            });
        });
    }


    $(".search-page__tabs-btn").first().addClass("active");

    $(".search-page__content-item").first().addClass("active");


    function setCookie(name, value, hours) {
        document.cookie = name + "=" + value + "; max-age=" + (hours * 3600) + "; path=/";
    }
    function getCookie(name) {
        return document.cookie.split('; ').find(row => row.startsWith(name + '='))?.split('=')[1];
    }

    if (!getCookie("site_lang")) {
        $('.modal__lang').show();
        $('body').addClass('hidden');
    }

    $('.modal__lang-link').on('click', function () {
        setCookie("site_lang", $(this).attr('href'), 72);
        $('.modal__lang').fadeOut();
        $('body').removeClass('hidden');
    });

    $('.modal__close, .modal-overlay').on('click', function () {
        setCookie("site_lang", "skip", 72);
        $('.modal__lang').fadeOut();
        $('body').removeClass('hidden');
    });


    const flipBtn = $('.flip-btn');
    if (!flipBtn.length) return;

    setInterval(() => {
        flipBtn.toggleClass('flipped');
    }, 5000);

    $(document).on('click', '.js-open-chat-item', function () {
        $('.chat__holder').toggle();
        $('.chat__overlay').toggle();
        $('.chat_btn_icon').toggle();
        $('.close_chat_btn_icon').toggle();
    });

    $(document).on('click', '.chat__overlay', function () {
        $('.chat__holder').hide();
        $('.chat__overlay').hide();
        $('.chat_btn_icon').show();
        $('.close_chat_btn_icon').hide();
    });

    $('.nav__inner').hover(
        function () {
            $('body').addClass('hidden');
        },
        function () {
            $('body').removeClass('hidden');
        }
    );

    function initSecondActiveItem() {
        if ($(window).width() > 567) {
            $('.nav__list-item--first').each(function () {
                let firstWithChildren = $(this)
                    .find('.nav__list-item--second')
                    .has('.nav__list--third')
                    .first();

                if (firstWithChildren.length) {
                    firstWithChildren.addClass('active');
                    firstWithChildren.find('.nav__list-link--second').addClass('active');
                }
            });
        } else {
            // на мобилках убираем активы
            $('.nav__list-item--second').removeClass('active');
            $('.nav__list-link--second').removeClass('active');
        }
    }

    $(document).ready(initSecondActiveItem);
    $(window).resize(initSecondActiveItem);



    function initHoverMenu() {
        if ($(window).width() > 567) {
            $('.nav__list-item--second').off('mouseenter mouseleave').hover(function () {
                $('.nav__list--third').removeClass('active');
                $('.nav__list-item--second').removeClass('active');
                $('.nav__list-link--second').removeClass('active');

                $(this).addClass('active');
                $(this).find('.nav__list--third').addClass('active');
                $(this).find('.nav__list-link--second').addClass('active');
            });
        } else {
            // убираем hover-эффект на мобилках
            $('.nav__list-item--second').off('mouseenter mouseleave');
        }
    }

    $(document).ready(initHoverMenu);
    $(window).resize(initHoverMenu);



    $('.js-btn-more-specialiast-area').on('click', function () {
        $('.js-btn-hide-specialiast-area').show();
        $(this).hide();
        $('.specialiast-area__item').addClass('active');
    });

    $('.js-btn-hide-specialiast-area').on('click', function () {
        $(this).hide();
        $('.js-btn-more-specialiast-area').show();
        $('.specialiast-area__item').removeClass('active');
    });


    let navTimer;

    function initFirstHoverMenu() {
        let navTimer;

        if ($(window).width() > 567) {
            // Убираем клики на мобилках (если они были)
            $('.nav__arrow').off('click');

            // Навешиваем hover для десктопа
            $('.nav__list-item--first').off('mouseenter mouseleave').hover(
                function () {
                    clearTimeout(navTimer);
                    let $this = $(this);

                    if ($('.nav__inner--first.open').length === 0) {
                        $('.nav__inner--first').removeClass('open');
                        $this.find('.nav__inner--first').addClass('open');
                        $this.find('.nav__list-link--children').addClass('active');
                    } else {
                        navTimer = setTimeout(function () {
                            $('.nav__inner--first').removeClass('open');
                            $('.nav__list-link--children').removeClass('active');
                            $this.find('.nav__inner--first').addClass('open');
                            $this.find('.nav__list-link--children').addClass('active');
                        }, 400);
                    }
                },
                function () {
                    clearTimeout(navTimer);
                    if (!$('.nav__bottom:hover').length) {
                        $('.nav__inner--first').removeClass('open');
                        $('.nav__list-link--children').removeClass('active');
                    }
                }
            );
        } else {
            // Убираем hover на мобилках
            $('.nav__list-item--first').off('mouseenter mouseleave');

            // Навешиваем click для мобилок
            $('.nav__arrow').off('click').on('click', function (e) {
                e.preventDefault();
                let $parent = $(this).closest('.nav__list-item--first');

                // toggle вложенного меню
                $parent.find('.nav__inner--first').toggleClass('open');
                $parent.find('.nav__list-link--children').toggleClass('active');
                $(this).toggleClass('active');
            });
        }
    }

    $(document).ready(initFirstHoverMenu);
    $(window).resize(initFirstHoverMenu);


    $(document).ready(initFirstHoverMenu);
    $(window).resize(initFirstHoverMenu);




    $('.nav__bottom').mouseleave(function () {
        $('.nav__inner--first').removeClass('open');
    });

    $('.js-close-hover--desc').on('click', function () {
        $('.nav__inner--first').removeClass('open');
    });


    $('.js-open-mob-menu').on('click', function () {
        $('.nav__list--first').toggle();
    });

    $('.js-close-hover--mob').on('click', function () {
        $('.nav__list--first').hide();
    });

    $('.js-open-mob-search').on('click', function () {
        $('.search__toggle').toggle();
    });

    function toggleNavTop() {
        if ($(window).width() < 768) {
            if ($(window).scrollTop() > 0) {
                $('.nav__top').hide();
                $('.mobile-phone').show();
                $('.header__holder').addClass('active');
                $('.nav').addClass('active');
                $('.header__logo').addClass('active');
            } else {
                $('.nav__top').show();
                $('.mobile-phone').hide();
                $('.header__holder').removeClass('active');
                $('.nav').removeClass('active');
                $('.header__logo').removeClass('active');
            }
        } else {
            $('.nav__top').show();
            $('.mobile-phone').hide();
            $('.header__holder').removeClass('active');
            $('.nav').removeClass('active');
            $('.header__logo').removeClass('active');
        }
        updateMainPadding();
    }

    $(window).on('scroll', toggleNavTop);

    $(window).on('resize', toggleNavTop);

    toggleNavTop();

    $('.nav__list-item--menu .nav__list-link--children').on('click', function () {
        event.preventDefault()
    });

});
